/**
 * The resources that derive from IGraphTaskCreationResource contain information about
 * the origin of the plannerTask.
 */ export var TaskCreationSourceKind;
(function(TaskCreationSourceKind) {
    /** External creation source */ TaskCreationSourceKind["External"] = "external";
    /** Publication creation source */ TaskCreationSourceKind["Publication"] = "publication";
})(TaskCreationSourceKind || (TaskCreationSourceKind = {}));
